module.exports = {
  methods: {
    prospectName (prospect) {
      const { type, name, company, account } = prospect

      switch (type) {
        case 'account':
          return name
        case 'lead':
          return company
        case 'contact':
          return account ? account.name : name
      }
    },
    activityTitle (activity) {
      let activityTitle = 'Unknown Prospect'

      if (activity.prospect) {
        activityTitle = this.prospectName(activity.prospect)
      } else if (activity.title) {
        activityTitle = activity.title
      }
      return activityTitle
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/activity.js